import { ReactComponent as IconMyPersona } from "@/assets/svgs/my-persona-size40.svg";
import CONSTANTS from "@/public/locales/en/translation.json";

const constants = CONSTANTS.USE_CASE_DETAILS.APPLICABLE_PERSONAS;

const ApplicablePersonas = ({ selectedPersona }) => {
	return (
		<>
			<div className="app-persona-wrapper">
				<div className="app-persona-container">
					<div className="--with-icon">
						<div className="persona-avatar">
							<IconMyPersona />
						</div>
						<div className="--title-wrapper">
							<div className="header">
								{selectedPersona?.name}
							</div>
							<div className="content">
								{selectedPersona?.description}
							</div>
						</div>
					</div>
				</div>
				<div className="section-divider"></div>
				<div className="app-persona-container">
					<div className="header">{constants.Value_Drivers}</div>
					<div className="content">
						{selectedPersona?.keyvaluedrivers?.map((data) => {
							return <div key={data}>{data}</div>;
						})}
					</div>
				</div>
				<div className="section-divider"></div>
				<div className="app-persona-container">
					<div className="-columns">
						<div className="--column">
							<div className="header">
							{constants.Recommended_Contribute}
							</div>

							<div className="content-grey">
								{selectedPersona?.contributes?.map((data) => {
									return (
										<div
											key={data.id}
											className="--list-item"
										>
											{data?.name}
										</div>
									);
								})}
							</div>
						</div>
						<div className="--column">
							<div className="header">{constants.Recommended_Consume}</div>

							<div className="content-grey">
								{selectedPersona?.consumes?.map((data) => {
									return (
										<div
											key={data.id}
											className="--list-item"
										>
											{data?.name}
										</div>
									);
								})}
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default ApplicablePersonas;
